var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      staticStyle: { "pointer-events": "auto" },
      attrs: {
        title: _vm.$t("details"),
        visible: _vm.dialogFormVisible,
        "close-on-click-modal": false,
        "modal-append-to-body": true,
        modal: false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        { ref: "ruleForm", staticClass: "popover" },
        _vm._l(_vm.params, function(domain, index) {
          return _c("div", { key: index + "k", staticClass: "paramsClass" }, [
            _c(
              "div",
              { staticClass: "lodingItem-operationFrame flex" },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "lodingItem",
                    staticStyle: { "margin-right": "20px" }
                  },
                  [
                    _c("el-input", {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.lableDetail[domain.k],
                        callback: function($$v) {
                          _vm.$set(_vm.lableDetail, domain.k, $$v)
                        },
                        expression: "lableDetail[domain.k]"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { staticClass: "lodingItem" },
                  [
                    _c("el-input", {
                      attrs: { disabled: true },
                      model: {
                        value: domain.v,
                        callback: function($$v) {
                          _vm.$set(domain, "v", $$v)
                        },
                        expression: "domain.v"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        }),
        0
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", round: "" },
              on: {
                click: function($event) {
                  _vm.dialogFormVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }